module.exports = __webpack_public_path__ + "img/physics5.e660d66a.png";